import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { AddNewServicesAgreementForm } from 'components'
import { useHistory } from 'react-router-dom'
import { isEqual } from 'lodash'

const propTypes = {
  completeServicesAgreementForm: Types.completeServicesAgreementForm,
  resetErisapediaSearches: PropTypes.func.isRequired,
  setCompleteServicesAgreementForm: PropTypes.func.isRequired,
  currentUser: Types.user.isRequired,
  formType: PropTypes.string.isRequired,
  nextPath: PropTypes.string.isRequired,
}

const defaultProps = {
  completeServicesAgreementForm: {
    planDetails: {
      name: '',
      ein: '',
    },
    signingMethod: '',
    option: '',
  },
}

function AddNewServicesAgreementView({
  completeServicesAgreementForm,
  resetErisapediaSearches,
  setCompleteServicesAgreementForm,
  currentUser,
  formType,
  nextPath,
}) {
  const history = useHistory()

  const isBackNavigation = history.location.state?.inWorkflow === true
  const formInitialValues = isBackNavigation
    ? completeServicesAgreementForm
    : defaultProps.completeServicesAgreementForm

  const handleSubmit = (values) => {
    const { planDetails: existingPlanDetails } = completeServicesAgreementForm
    const hasExistingValues = !!existingPlanDetails.ein

    if (
      hasExistingValues &&
      !isEqual(existingPlanDetails, values.planDetails)
    ) {
      resetErisapediaSearches()
      setCompleteServicesAgreementForm({ ...values, option: '' })
    } else {
      setCompleteServicesAgreementForm(values)
    }

    history.replace({
      ...history.location,
      state: { ...history.location.state, inWorkflow: true },
    })
    history.push({
      pathname: nextPath,
      state: {
        search: history.location.state?.search,
      },
    })
  }

  return (
    <div className="card full-height complete-services-agreement-view">
      <div className="complete-services-agreement-form-container">
        <div className="form-masthead">
          <h2>Search for your plan and choose your signature preference</h2>
        </div>
        <div className="form-section form-section--with-top-border">
          <AddNewServicesAgreementForm
            formType={formType}
            initialValues={formInitialValues}
            onSubmit={handleSubmit}
            accountAudience={currentUser.accountAudience}
          />
        </div>
      </div>
    </div>
  )
}

AddNewServicesAgreementView.propTypes = propTypes
AddNewServicesAgreementView.defaultProps = defaultProps

export default AddNewServicesAgreementView
